


<template>
	<div>
		<panel title="Пополнить счет">
			<!-- BEGIN panel -->
			<div class="card  border-0 mb-3">
				<div class="card-body">
					<validation-observer ref="form">
						<form v-on:submit="checkForm" method="GET" class="fs-13px">
							<div class="row">
								<legend>Пополнить счет:</legend>
								<validation-provider #default="{ errors }" name="sum"
									rules="required|min_value:1|max_value:15000" vid="sum">
									<div class="row mb-15px">
										<label class="form-label col-form-label col-md-2">Сумма</label>
										<div class="col-md-10">
											<input type="text" v-model="data.sum" class="form-control fs-15px"
												id="floatingInput" placeholder="">
											<small v-show="!errors[0]">Сумма ot 1 до 15000 рублей</small>
											<small class="text-danger">{{ errors[0] }}</small>
										</div>
									</div>
								</validation-provider>

								<validation-provider #default="{ errors }" name="email" rules="required|email"
									vid="email">
									<div class="row mb-15px">
										<label class="form-label col-form-label col-md-2">Email</label>
										<div class="col-md-10">
											<input type="email" v-model="data.email" class="form-control fs-15px"
												id="floatingInput" placeholder="">
											<small v-show="!errors[0]">Email на который будет выслан чек </small>
											<small class="text-danger">{{ errors[0] }}</small>
										</div>
									</div>
								</validation-provider>
							</div>
							<div class="row mb-3">
								<label class="form-label col-form-label col-md-3">Платежная система:</label>
								<div class="col-md-9 pt-2">
									<div class="form-check mb-2">
										<input class="form-check-input" type="radio" name="flexRadioDefault"
											id="flexRadioDefault1" checked="true" v-model="data.type" value="ROBO">
										<label class="form-check-label" for="flexRadioDefault1">
											<b>RoboKassa</b>: банковские карты, QIWI, YooMoney

										</label>
									</div>
									<!-- Payeer / QiWi hidden -->
								</div>
							</div>
							<div class="d-flex justify-content-center mb-3">
								<button :disabled="loading" @click="checkForm()"
									class="btn btn-white  btn-lg fs-14px w-150px">
									<i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
									<span v-show="!loading">Пополнить</span>
								</button>
							</div>
							<div v-if="payin" class="alert  alert-primary  h-200">
								<div class="d-flex justify-content-between align-self-center">
									<div class="d-flex  align-self-center">
										Ваш счет ID{{ payin.id }} на сумму {{ payin.sum }} руб. создан
									</div>
									<div>
										<a :href="pay_link" target="_blank" class="btn btn-primary w-100px">Оплатить</a>
									</div>
								</div>
							</div>

							<div v-if="status && status   ==   'success'" class="alert  alert-primary  h-110">
								<div class="d-flex justify-content-between align-self-center">
									<div class="d-flex  align-self-center">
										Ваш платеж принят.
									</div>
									<div>
										<button :disabled="loading" @click="fetchData()"
											class="btn btn-primary  btn-lg fs-14px w-120px">
											<i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
											<span v-show="!loading">Обновить</span>
										</button>
									</div>
								</div>
							</div>
							<div v-else-if="status && status   ==   'fail'" class="alert  alert-warning  h-200">
								<div class="d-flex justify-content-between align-self-center">
									<div class="d-flex  align-self-center">
										Ошибка платежа
									</div>
									<div>
										<button :disabled="loading" @click="fetchData()"
											class="btn btn-warning  btn-lg fs-14px w-120px">
											<i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
											<span v-show="!loading">Обновить</span>
										</button>
									</div>
								</div>
							</div>
						</form>
					</validation-observer>
				</div>

				<h3>История пополнений:</h3>

				<table class="table table-hover">
					<thead>
						<tr>
							<th>
								<h5>ID</h5>
							</th>
							<th>
								<h5>Дата</h5>
							</th>
							<th class="hide-576">
								<h5>Тип</h5>
							</th>
							<th class="text-center">
								<h5>Сумма</h5>
							</th>
							<th>
								<h5>Статус</h5>
							</th>
							<th class="hide-576">
								<h5>Email</h5>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="payin in payins" v-bind:key="payin.id">
							<td>
								{{ payin.id }}
							</td>
							<td>
								{{ payin.created_at }}
							</td>
							<td v-html="payin.type" class="hide-576">
							</td>
							<td class="text-center">
								{{ payin.sum }}
							</td>
							<td v-html="payin.status">
							</td>
							<td class="hide-576">
								{{ payin.email }}
							</td>
						</tr>
						<tr v-if="!payins.length">
							<td colspan="5" align="center">У вас нет пополнений </td>
						</tr>
					</tbody>
				</table>

			</div>
			<!-- END panel -->
		</panel>
	</div>
</template>


<script>
	import HTTP from "../http";
	import { show_error, show_message } from "../message";
	import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
	import { required, email, max, min, max_value, min_value } from 'vee-validate/dist/rules';
	extend('required', required);
	extend('email', email);
	extend('min', min);
	extend('max', max);
	extend('max_value', max_value);
	extend('min_value', min_value);


	export default {
		components: {
			ValidationProvider,
			ValidationObserver
		},
		data() {
			return {
				loading: false,
				errors: null,
				title: null,
				data: {
					sum: 0,
					email: 0,
					type: "ROBO"
				},
				user: null,
				payins: [],
				payin: null,
				pay_link: '',
				status: null
			};
		},

		created() {

			this.status = this.$route.params.status || null

			this.user = JSON.parse(localStorage.getItem('user'))
			this.data = { sum: 300, email: this.user.email, type: "ROBO" }
			this.fetchData()
		},

		methods: {
			checkForm: function () {
				this.$refs.form.validate().then(success => {
					//e.preventDefault();
					if (!success) {
						return;
					}
					this.$insProgress.start();
					this.loading = true;
					HTTP()
						.post("/payin", this.data)
						.then((resp) => {
							console.log(resp.data)
							show_message(
								this.$notify,
								'Счет создан'
							);
							this.data.sum = 0
							this.payin = resp.data.payin;
							this.pay_link = resp.data.pay_link;
							setTimeout(() => { this.fetchData() }, 500);

						})
						.catch((error) => {
							show_error(this.$notify, this.$refs.form, error.response.data)
						})
						.finally(() => {
							this.loading = false;
							this.$insProgress.finish();
						});
				})
			},
			fetchData() {
				this.loading = true;
				this.$insProgress.start();

				HTTP()
					.get(`/payin`)
					.then((resp) => {
						console.log('resp', resp)
						this.payins = resp.data.payins;
						localStorage.setItem('user', JSON.stringify(resp.data.user))
						window.eventBus.$emit('user.update', resp.data.user)
					})
					.catch((error) => {
						show_error(this.$notify, this.$refs.form, error.response.data)
					})
					.finally(() => {
						this.loading = false;
						this.$insProgress.finish();
					});
			},

		}
	}

</script>


<style>
.task-href {
	cursor: pointer;
	text-decoration: none;
	color: var(--bs-body-color);
}

.task-href:visited {
	color: var(--bs-body-color);
}

.task-href:hover {
	color: var(--bs-body-color);
}

.w-120px {
	width: 120px !important;
}
</style>

